export function DEBUG_CLOSE_ALL_FORMS() {
  return window.localStorage.getItem('debugCloseAllForms')
}